<template lang="html">
  <div class="handling-box-wrapper">
    <div class="top-btn-wrap">
      <span @click="addHandling">添加装卸</span>
    </div>
    <el-form
      ref="ruleForm"
      label-width="50"
      label-position="left"
      :model="ruleForm"
      :rules="rules"
      :validate-on-rule-change="false"
    >
      <el-collapse
        accordion
        class="handling-content"
        v-model="activeNames"
        v-for="(value, key, index) in ruleForm"
        :key="index"
      >
        <el-card shadow="hover" class="handling-box">
          <el-collapse-item :title="`装卸信息${index + 1}`" :name="index + 1">
            <!-- <div
              class="del-btn"
              @click="delHandling(index)"
              v-if="Object.keys(ruleForm).length > 1"
            >
              删除
            </div> -->
            <handling-card
              ref="handlingCard"
              :cardKey="Number(key)"
              :ruleForm="ruleForm"
              :rules="rules"
              :showDelHandling="showDelHandling"
              @delHandling="delHandling(key)"
              @goodsDel="goodsDel"
              @addToCommonUse="addToCommonUse"
              @addGoodsSuccess="addGoodsSuccess"
              @addGoodsValidate="addGoodsValidate"
            />
          </el-collapse-item>
        </el-card>
      </el-collapse>
    </el-form>
    <!-- 添加装卸弹窗 -->
    <add-handling-dialog
      :dialogVisible.sync="handlingVisible"
      @addHandlingSuccess="addHandlingSuccess"
    />
  </div>
</template>

<script>
import handlingCard from "@/views/personal/deliver/components/handlingWrapper/components/handlingCard";
import addHandlingDialog from "@/views/personal/deliver/components/handlingWrapper/components/addHandlingDialog";

import { handlingMixins } from "@/views/personal/deliver/components/handlingWrapper/mixins/handlingMixins";

export default {
  mixins: [handlingMixins],
  data() {
    return {
      activeNames: 1,
      handlingVisible: false,
      showDelHandling: false
    };
  },
  computed: {
    // showDelHandling() {
    //   return Object.keys(this.ruleForm).length > 1;
    // }
  },
  created() {
    this.initData();
  },
  methods: {
    async addHandling() {
      try {
        await this.formValidate();
        this.handlingVisible = true;
      } catch (e) {
        return false;
      }
    },
    addHandlingSuccess(ruleForm) {
      let len = Object.keys(this.ruleForm).length;
      this.ruleForm[len] = ruleForm[0];
      this.activeNames = len + 1;
      this.setHandlingShow();
      this.setRules();
    },
    setHandlingShow() {
      this.showDelHandling = !!(Object.keys(this.ruleForm).length > 1);
    },
    async delHandling(bigIndex) {
      await this.$myConfirm("确定要删除此装卸吗", this);
      this.ruleForm = {
        ...Object.values(this.ruleForm).filter(
          (item, index) => Number(bigIndex) !== index
        )
      };
      this.activeNames = 1;
      this.setHandlingShow();
      this.setRules();
    }
  },
  watch: {},
  components: {
    addHandlingDialog,
    handlingCard
  }
};
</script>

<style lang="scss">
.handling-box-wrapper {
  .top-btn-wrap {
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 20px;
    span {
      color: #00a7f7;
      cursor: pointer;
    }
  }
  .handling-content {
    .handling-box {
      .el-card__body {
        padding-bottom: 20px;
      }
    }
    &.el-collapse {
      border-top: none !important;
      border-bottom: none !important;
    }
    .el-card {
      margin-bottom: 20px;
    }
    .el-collapse-item__header {
      font-size: 18px;
      font-weight: bold;
      border-bottom: none !important;
    }
    .el-collapse-item__wrap {
      border-bottom: none;
      .el-collapse-item__content {
        padding-bottom: 0;
      }
    }
    &:last-child {
      border-bottom: none;
    }
    &:not(:first-child) {
      .handling-title {
        padding-top: 20px;
      }
    }
    .handling-title {
      font-size: 18px;
      font-weight: bold;
      color: #464646;
    }
    .del-btn {
      display: flex;
      flex-direction: row-reverse;
      padding-right: 20px;
      color: #f56c6c;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/deliver/components/handlingWrapper/index.vue